import Parking, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/parking/[slug]';

import NewParking from '@pages/myapp/parking/[slug]';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;
// Charlotte-International-Airport-CLT
function VParking({
  landing,
  baseUrlSite,
  airports,
  searchAlternate,
  configInfo,
  deviceType,
  mobileType,
  checkin,
  checkout,
  fixedReviews,
  googleNews,
  ctxLat,
  ctxLng,
}) {
  return (
    <NewParking
      landing={landing}
      baseUrlSite={baseUrlSite}
      airports={airports}
      searchAlternate={searchAlternate}
      configInfo={configInfo}
      deviceType={deviceType}
      mobileType={mobileType}
      checkin={checkin}
      checkout={checkout}
      fixedReviews={fixedReviews}
      googleNews={googleNews}
      ctxLat={ctxLat}
      ctxLng={ctxLng}
    />
  );
}

export default VParking;
